module.exports = __webpack_public_path__ + "img/registro-aside.7b44cbf4.svg";